// src/layout/AdminLayout.tsx
import React, { useState } from "react";
import styled from "styled-components";
import Sidebar from "./Sidebar";
import Header from "./Header";

const LayoutWrapper = styled.div`
  display: flex;
  height: 100vh;
  background-color: #f9fafb;
  width: 100%;
  overflow: hidden;
`;

const ContentWrapper = styled.div<{ $collapsed: boolean }>`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin-left: ${({ $collapsed }) => ($collapsed ? "72px" : "240px")};
  transition: margin-left 0.2s ease;
`;

const MainContent = styled.main`
  flex: 1 1 auto;
  padding: 24px;
  min-width: 0;
  overflow-y: auto;
  overflow-x: auto;
`;

const Layout = ({ children }: { children: React.ReactNode }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <LayoutWrapper>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <ContentWrapper $collapsed={collapsed}>
        <Header />
        <MainContent>{children}</MainContent>
      </ContentWrapper>
    </LayoutWrapper>
  );
};

export default Layout;
